import systemSettingApi from '@/api/system-setting'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  delivery: false,
  bakai: false,
  crm: true,
  rk7: true,
  errors: {
    errors: [],
    commonErrors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  fetch({ commit }) {
    commit('FORM_RESET')

    return systemSettingApi.getExchangeLogSettings()
      .then(({ data }) => commit('SETTINGS_FETCHED', data))
      .catch(err => commit('SETTINGS_FETCH_FAILED', err))
  },
  update({ commit }) {
    const { delivery, bakai, crm, rk7 } = state

    return systemSettingApi.updateExchangeLogSettings({
 delivery, bakai, crm, rk7,
})
      .then(() => commit('SETTINGS_UPDATED'))
      .catch(error => {
        commit('SETTINGS_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  SETTINGS_FETCHED(state, data) {
    state.delivery = data.delivery
    state.bakai = data.bakai
    state.crm = data.crm
    state.rk7 = data.rk7
  },
  SETTINGS_FETCH_FAILED() {
    store.dispatch('message/error', 'Не удалось прочитать настройки')
  },
  SETTINGS_UPDATED() {
    store.dispatch('message/success', 'Настройки сохранены')
  },
  SETTINGS_UPDATE_FAILED(state, errors) {
    Object.assign(state.errors, errors)
    store.dispatch('message/error', 'Не удалось сохранить настройки')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
